import React from "react";
import { Title } from "./messageStyle";

const Message = ({ weight, space, size, children, color }) => {
  return (
    <Title space={space} size={size} weight={weight} color={color}>
      {children}
    </Title>
  );
};
export default Message;
